import { useAuth } from "oidc-react";

import CenteredSpinner from "@topgun/shared-front-end/src/components/CenteredSpinner";

function SignOut() {
  const { signOut } = useAuth();
  void signOut();

  return <CenteredSpinner size="large" />;
}

export default SignOut;
